import {classNames, observer, React} from '@api'
import {useGroupByGroupStore} from '@modules'
import css from './GroupByProductsToolbar.css'

interface MyProps {
  className?: string
}

export const GroupByProductsToolbar = observer<MyProps>(({className}) => {
  const store = useGroupByGroupStore()

  return <div className={classNames(css.root, className)}>
    toolbar
  </div>
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByProductsToolbar.tsx